/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { iccidActions, iccidConstants } from '../../../modules/iccid/actions';
import { history } from '../../../core/history';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../../components/Translate/I18n';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from '../../../components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';

import { IccidRange, IccidRangeStatus } from '../../../modules/iccid/EntityRange';

import { ImportExport } from '@material-ui/icons/index';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import InputFormRest from '../../../components/Form/InputFormRest';
import CustomButtom from '../../../components/CustomButtons/ButtonExt';
import CancelTextButton from '../../../components/Buttons/CancelTextButtons';
import IndicatedRange from '../../../components/Adescom/SimpleSelectRest';
import TariffsRange from '../../../components/Adescom/SimpleSelectRest';
import PlatformResellersRange from '../../../components/Adescom/SimpleSelectRest';
import { store } from '../../../core/store';
import { iccidReducers } from '../../../modules/iccid/reducers';

class IccidChange extends Component {
    constructor(props) {
        super(props);

        store.injectReducer('iccidReducers', iccidReducers);

        this.state = {
            entity: IccidRange,
            entityStatus: IccidRangeStatus,
            success: false,
            indicatedRanges: null,
            tariffs: null,
            platformResellers: null,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(
            iccidActions.getList(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/indicated_ranges')),
                [
                    { name: 'typeResource', value: 'sim' },
                    { name: 'typeSystem', value: 'mvno' },
                ],
                [],
                iccidConstants.LIST_ICCID_POOL_GET_INDICATED_RANGE
            )
        );
        dispatch(
            iccidActions.getList(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
                [],
                [{ name: 'mainname', value: 'asc' }],
                iccidConstants.ICCID_POOL_PLATFORM_RESELLERS
            )
        );
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.indicatedRanges && this.state.indicatedRanges === null) {
            this.setState({ indicatedRanges: nextProps.indicatedRanges });
            return false;
        }
        if (nextProps.tariffs && this.state.tariffs === null) {
            this.setState({ tariffs: nextProps.tariffs });
            return false;
        }
        if (nextProps.platformResellers && this.state.platformResellers === null) {
            this.setState({ platformResellers: nextProps.platformResellers });
            return false;
        }
        if (nextProps.success) {
            this.returnToList();
            return false;
        }
        return true;
    }

    reloadTariffList() {
        const { dispatch } = this.props;
        dispatch(
            iccidActions.getList(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/tariffs')),
                [{ name: 'indicatedRangeId', value: this.state.entity.indicatedRangeId }],
                [{ name: 'mainname', value: 'asc' }],
                iccidConstants.LIST_ICCID_POOL_GET_TARIFFS
            )
        );
    }

    selectFunc = (e, stateName, require) => {
        FormGeneralHelper.selectFunc(this, e, stateName, require, () => {
            if (stateName === 'indicatedRangeId') {
                this.setState({ tariffs: null }, this.reloadTariffList());
            }
        });
    };

    returnToList = () => {
        history.push(FormGeneralHelper.getRouteUrl('/iccid-storage'));
    };

    handleSubmit = (e) => {
        const { dispatch } = this.props;
        FormGeneralHelper.handleSubmit(this, e, this.submitCallBackDispatch, false, dispatch);
    };

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    submitCallBackDispatch = () => {
        const { dispatch } = this.props;
        this.setState(
            (prevState) => ({
                entity: {
                    ...prevState.entity,
                    apn: 0,
                },
            }),
            () =>
                dispatch(
                    iccidActions.put(
                        FormGeneralHelper.getUrl('/platform_iccid_ranges/1'),
                        this.state.entity,
                        iccidConstants.LIST_ICCID_POOL_EDIT_SAVE
                    )
                )
        );
    };

    render() {
        const { classes } = this.props;
        const { entity, entityStatus, indicatedRanges, tariffs, platformResellers } = this.state;
        return (
            <form onSubmit={this.handleSubmit} key="pools_form">
                <GridContainer>
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <ImportExport />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    <I18n trans="pools:assign.assign_pool_msisdn" />
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={6}>
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="fromImsi"
                                            stateObjectState={entityStatus.fromImsi}
                                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="pools:add.from_imsi"
                                            vMax={17}
                                            vMin={15}
                                            required={true}
                                            value={entity.fromImsi}
                                            labelText="pools:add.from_number"
                                        />
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="toImsi"
                                            stateObjectState={entityStatus.toImsi}
                                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="pools:add.to_imsi"
                                            vMax={17}
                                            vMin={15}
                                            required={true}
                                            value={entity.toImsi}
                                            labelText="pools:add.to_imsi"
                                        />
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <IndicatedRange
                                            callback={this.selectFunc}
                                            restElements={indicatedRanges}
                                            stateName="indicatedRangeId"
                                            idState={this.state.entityStatus.indicatedRangeId}
                                            idSelected={this.state.entity.indicatedRangeId}
                                            propKey="id"
                                            propValue="mainname"
                                            required={true}
                                            emptyLabel="general:common.empty_label"
                                            label="general:common.indicated_range"
                                        />
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <TariffsRange
                                            callback={this.selectFunc}
                                            restElements={tariffs}
                                            stateName="tariffId"
                                            idState={this.state.entityStatus.tariffId}
                                            idSelected={this.state.entity.tariffId}
                                            propKey="id"
                                            required={false}
                                            propValue="tariffName"
                                            emptyLabel="general:common.empty_label"
                                            label="tariffs:t.tariff"
                                        />
                                    </GridItem>

                                    <GridItem xs={12}>
                                        <PlatformResellersRange
                                            callback={this.selectFunc}
                                            restElements={platformResellers}
                                            stateName="ownerPlatformResellerId"
                                            idState={this.state.entityStatus.ownerPlatformResellerId}
                                            idSelected={this.state.entity.ownerPlatformResellerId}
                                            propKey="id"
                                            required={true}
                                            propValue="mainname"
                                            emptyLabel="general:common.empty_label"
                                            label="platform_reseller:select.choose_reseller"
                                        />
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <CustomButtom type="submit">
                                            <I18n trans="pools:assign.assign_pools" />
                                        </CustomButtom>
                                        <CancelTextButton callback={this.returnToList} />
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </form>
        );
    }
}

IccidChange.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { iccidReducers } = state;
    if (iccidReducers === undefined) {
        return { ...state };
    }
    let success = false;
    let indicatedRanges = null;
    let tariffs = null;
    let platformResellers = null;
    if (iccidReducers) {
        if (iccidReducers.success) {
            success = iccidReducers.success;
        }
        if (iccidReducers.indicatedRanges) {
            indicatedRanges = iccidReducers.indicatedRanges;
        }
        if (iccidReducers.tariffs) {
            tariffs = iccidReducers.tariffs;
        }
        if (iccidReducers.platformResellers) {
            platformResellers = iccidReducers.platformResellers;
        }
    }
    return {
        success: success,
        indicatedRanges: indicatedRanges,
        tariffs: tariffs,
        platformResellers: platformResellers,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(IccidChange);
export default Enhance;
